/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import moment from 'moment-timezone';
import Model, { helper } from '@tripian/model';
import { ChevronDown, ChevronUp } from '../../base/Svg/Icons';
import classes from './OpenedHours.scss';

interface IOPenedHours {
  hourStr: string;
  timezone: string;
  planDate?: string;
  t: (value: Model.TranslationKey) => string;
}

interface IHourItem {
  hour: { day: string; clock: string[] };
  lineHeight?: string;
  current?: boolean;
}

const isPlaceOpen = (clock: string[], timezone: string): boolean => {
  // clock string veya array olarak gelebilir
  const timeRanges = Array.isArray(clock) ? clock : [clock];

  if (!timeRanges || timeRanges.length === 0) return false;

  // Eğer sadece "Closed" varsa
  if (timeRanges.length === 1 && timeRanges[0].toLowerCase() === 'closed') {
    return false;
  }

  // 24 saat açık kontrolü
  if (timeRanges.length === 1 && timeRanges[0].toLowerCase().includes('24 hours')) {
    return true;
  }

  const currentMoment = moment().tz(timezone);
  // console.log('Current time in timezone:', timezone, currentMoment.format('HH:mm'));

  // Tüm zaman aralıklarını kontrol et
  return timeRanges.some((timeRange) => {
    try {
      // Eğer geçerli bir zaman aralığı değilse veya "Closed" ise, bu aralığı atla
      if (!timeRange || timeRange.toLowerCase() === 'closed' || !timeRange.includes('-')) {
        return false;
      }

      const [openTimeStr, closeTimeStr] = timeRange.split('-').map((t) => t.trim());

      // Geçerli saat formatı kontrolü
      const timeFormat = /^\d{1,2}:\d{2} [AP]M$/;
      if (!timeFormat.exec(openTimeStr) || !timeFormat.exec(closeTimeStr)) {
        return false;
      }

      // AM/PM formatını doğru şekilde parse et
      const parseTime = (timeStr: string) => {
        const [time, period] = timeStr.split(' ');
        const [hours, minutes] = time.split(':').map(Number);
        let adjustedHours = hours;

        // 12 saat formatından 24 saat formatına çevir
        if (period === 'PM' && hours !== 12) {
          adjustedHours = hours + 12;
        } else if (period === 'AM' && hours === 12) {
          adjustedHours = 0;
        }

        return moment().tz(timezone).hours(adjustedHours).minutes(minutes).seconds(0);
      };

      const openMoment = parseTime(openTimeStr);
      const closeMoment = parseTime(closeTimeStr);

      // console.log('Checking time range:', {
      //   openTime: openMoment.format('HH:mm'),
      //   closeTime: closeMoment.format('HH:mm'),
      //   currentTime: currentMoment.format('HH:mm'),
      //   originalOpenTime: openTimeStr,
      //   originalCloseTime: closeTimeStr,
      // });

      // Geçersiz saat oluşturma durumunu kontrol et
      if (!openMoment.isValid() || !closeMoment.isValid()) {
        // console.log('Invalid moment objects');
        return false;
      }

      // Saatleri dakikaya çevirip karşılaştırma yapalım
      const currentMinutes = currentMoment.hours() * 60 + currentMoment.minutes();
      const openMinutes = openMoment.hours() * 60 + openMoment.minutes();
      const closeMinutes = closeMoment.hours() * 60 + closeMoment.minutes();

      // console.log('Minutes comparison:', {
      //   currentMinutes,
      //   openMinutes,
      //   closeMinutes,
      // });

      // Aynı gün içinde kontrol
      if (closeMinutes > openMinutes) {
        return currentMinutes >= openMinutes && currentMinutes <= closeMinutes;
      }

      // Gece yarısını geçen durum
      return currentMinutes >= openMinutes || currentMinutes <= closeMinutes;
    } catch (error) {
      // console.error('Error parsing time range:', timeRange, error);
      return false;
    }
  });
};

export const HourItem: React.FC<IHourItem> = ({ hour, lineHeight, current }) => (
  <div className={`${classes.hourItem} ${current ? classes.current : ''}`} key={`${hour.day}${hour.clock.join('-')}${Math.floor(Math.random() * 100 + 1)}`}>
    <span className={classes.day}>{hour.day}</span>
    <span className={classes.clock} style={{ lineHeight }}>
      {hour.clock[0]} <br />
      {hour.clock[1]}
    </span>
  </div>
);

const OpenedHours: React.FC<IOPenedHours> = ({ hourStr, timezone, planDate, t }) => {
  const [showHours, setShowHours] = useState<boolean>(false);

  moment.locale(window.twindow.langCode);

  const daysArray = [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')];

  // hours null veya undefined olabilir, type safety ekleyelim
  const hours = hourStr ? helper.hoursFormat(hourStr, daysArray, t('closed')) : [];
  const currentTime = moment().tz(timezone);
  const date = planDate ? moment(planDate).format('ddd') : currentTime.format('ddd');

  // Null check ekleyelim
  const findToday = hours && hours.length > 0 ? hours.find((hour) => hour?.day === date) : null;

  // clock array'i için type safety
  const isOpen = findToday && Array.isArray(findToday.clock) ? isPlaceOpen(findToday.clock, timezone) : false;

  return (
    <div className={classes.openedHours} role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => setShowHours(!showHours)}>
      <span className={`${classes.statusText} ${isOpen ? classes.open : classes.closed}`}>{isOpen ? t('open') : t('closed')}</span>
      <div className={classes.statusDot} />
      <div className={classes.hourContent}>
        {showHours ? (
          (hours || []).map((h, i) => <HourItem key={`${h?.day || ''}-${i}`} hour={h} current={h?.day === date} />)
        ) : (
          <>
            {findToday && <HourItem hour={findToday} />}
            {!findToday && hours && hours[0] && <HourItem hour={hours[0]} />}
          </>
        )}
      </div>
      <div>{showHours ? <ChevronDown size="16" /> : <ChevronUp size="16" />}</div>
    </div>
  );
};

export default OpenedHours;
